import { UseMutationResult, useMutation } from 'react-query';

import { getTokenWithType } from './useAuth';

import { procedureDownload } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

async function fetchHtmlContent({
  payload,
  accountId,
}: TVariables): Promise<any> {
  const response = await fetch(procedureDownload(accountId, payload), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.text();
}

type TError = ErrorModal;

type TVariables = {
  accountId: number;
  payload: string;
};

type TSnapshot = unknown;

function useSaveProcedureAsWord(): UseMutationResult<
  void,
  TError,
  TVariables,
  TSnapshot
> {
  return useMutation(
    async ({ accountId, payload }: TVariables): Promise<void> => {
      const fetchResponse = await fetchHtmlContent({
        accountId,
        payload,
      });
      if (fetchResponse) {
        return fetchResponse;
      }
      return;
    },
  );
}

export { useSaveProcedureAsWord };
